// extracted by mini-css-extract-plugin
export default {"radio_group":"WidgetSwitchVariants_radio_group__Cy7MG","form_radio":"WidgetSwitchVariants_form_radio__kQ52Z"};